import React from 'react';
import images from '../../Asset/Img/img';
import Form from '../Form/Form';
// import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';

// const lngs = {
//   tr: { nativeName: 'TR' },
//   en: { nativeName: 'EN' }
 
// }

function FooterDefault() {
  const { t } = useTranslation();
  return (
    <>
        
        <div className="footer-content">
        <div className='footer-info'>
          <img src={images.logoWhite} alt="Logo" />
          <p>{t('footer-info-header')}</p>
          <p><strong>{t('footer-address')}</strong>{t('footer-address-info')}</p>
          <p><strong>{t('footer-telephone')}</strong>
            +90 (224) 323 00 13</p>
          <p><strong>{t('footer-fax')}</strong>
            +90 (224) 323 00 14</p>
          <p><strong>{t('footer-email')}</strong>
            info@hpcompounds.com </p>
        </div>
        <div className='footer-form'>
          <Form/>
        </div>
      </div>

      <div className='copyright'>
        <p>{t('footer-form-copyright')}</p>
      </div>

    </>
  )
}

export default FooterDefault